// extracted by mini-css-extract-plugin
var _1 = "EmptyTable_emptyTableContainer__DYdKN";
var _2 = "EmptyTable_text__X7GJr";
export { _1 as "emptyTableContainer", _2 as "text" }
